export const theme = {
  codeColor: Styles.color.black,
};
